var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErc20Tokens(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2856 14.0555V8.56246H7.94434V7.33325H14.0554V8.56246H11.7241V14.0555H10.2856Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0011 3.05811C6.62671 3.05811 3.05664 6.62845 3.05664 11.0026C3.05664 15.3769 6.62699 18.947 11.0011 18.947C15.3755 18.947 18.9455 15.3766 18.9455 11.0026C18.9455 6.62817 15.3752 3.05811 11.0011 3.05811ZM11.0011 18.016C7.13385 18.016 3.98763 14.8698 3.98763 11.0026C3.98763 7.13531 7.13385 3.9891 11.0011 3.9891C14.8683 3.9891 18.0145 7.13531 18.0145 11.0026C18.0145 14.8698 14.8683 18.016 11.0011 18.016Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.94317 0 0 4.94355 0 11C0 17.0568 4.94355 22 11 22C17.0568 22 22 17.0564 22 11C22 4.94317 17.0564 0 11 0ZM11 20.7109C5.64536 20.7109 1.28906 16.3546 1.28906 11C1.28906 5.64536 5.64536 1.28906 11 1.28906C16.3546 1.28906 20.7109 5.64536 20.7109 11C20.7109 16.3546 16.3546 20.7109 11 20.7109Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErc20Tokens);
export default __webpack_public_path__ + "static/media/Erc20Tokens.7b16022bd77a0ecb6141c9cfc8daa128.svg";
export { ForwardRef as ReactComponent };